import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../../app-config.service';
import { DCarbonizeAppConfig } from 'app/@types/shared/app-config';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private config: DCarbonizeAppConfig = this.configService.getConfig;

    constructor(private configService: ConfigService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const userPoolId = this.config.cognitoUserPoolId;
        const clientId = this.config.cognitoAppClientId;

        if (userPoolId && clientId && this.config.client.name !== 'Dcarbonize') {
            const clonedRequest = req.clone({
                setHeaders: {
                    'Cognito-UserPoolId': userPoolId,
                    'Cognito-ClientId': clientId,
                },
            });
            return next.handle(clonedRequest);
        }

        return next.handle(req);
    }
}
